import { CallMethodEnums } from '@/types/api';
import {
  AuthLogoutRes,
  AuthTokenExchangeReq,
  AuthTokenExchangeRes,
  CapabilitiesGetRes,
  OrgInviteDeleteRes,
  OrgInviteReq,
  OrgInviteRes,
  OrgInvitesGetRes,
  OrgRolesGetRes,
  PasswordResetReq,
  PasswordResetRes
} from '@/types/auth';

import { call } from './utils';

export const authLogout = async(): Promise<AuthLogoutRes> => {
  const route = '/api/auth/tokens/sessions/logout';

  const json = await call<undefined, AuthLogoutRes>( {
    isProtected: true,
    method: CallMethodEnums.POST,
    route
  } );

  return json;
};

export const authTokenExchange = async( args: AuthTokenExchangeReq ): Promise<AuthTokenExchangeRes> => {
  const route = '/public/auth/tokens/sessions/exchange';

  const json = await call<AuthTokenExchangeReq, AuthTokenExchangeRes>( {
    body: args,
    isProtected: false,
    method: CallMethodEnums.POST,
    route
  } );

  return json;
};

export const orgUserInvite = async( args: OrgInviteReq ): Promise<OrgInviteRes> => {
  const route = '/api/auth/orgs/invites';

  const json = await call<OrgInviteReq, OrgInviteRes>( {
    body: args,
    isProtected: true,
    method: CallMethodEnums.POST,
    route
  } );

  return json;
};

export const orgRolesGet = async(): Promise<OrgRolesGetRes> => {
  const route = '/api/auth/orgs/roles';

  const json = await call<undefined, OrgRolesGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route
  } );

  return json;
};

export const orgInvitesGet = async(): Promise<OrgInvitesGetRes> => {
  const route = '/api/auth/orgs/invites';

  const json = await call<undefined, OrgInvitesGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route
  } );

  return json;
};

export const orgInviteDelete = async( invitationId: string ): Promise<OrgInviteDeleteRes> => {
  const route = `/api/auth/orgs/invites/${ invitationId }`;

  const json = await call<undefined, OrgInviteDeleteRes>( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route
  } );

  return json;
};

export const capabilitiesGet = async(): Promise<CapabilitiesGetRes> => {
  const route = '/api/auth/fga/capabilities';

  const json = await call<undefined, CapabilitiesGetRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route
  } );

  return json;
};

export const passwordResetRequest = async( args: PasswordResetReq ): Promise<PasswordResetRes> => {
  const { authClientDomain, authClientId, authOrgId, connection, email } = args;

  const response = await fetch( `https://${ authClientDomain }/dbconnections/change_password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( {
      client_id: authClientId,
      email,
      connection: connection || 'Username-Password-Authentication',
      organization: authOrgId
    } )
  } );

  if ( !response.ok ) {
    throw new Error( `Password reset request failed: ${ response.statusText }` );
  }

  return { success: true };
};
